class MultiColumnGridItem extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.checkIfInCart()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', (e) => {
      e.preventDefault()

      this.addToCart()
    })

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )

    document.addEventListener('cart:updated', () => {
      this.checkIfInCart()
    })

    document.addEventListener('cart:item-added', (e) => {
      if (e.detail.variantId === this.dataset.productId) {
        this.showTick()
      }
    })
  }

  onCartChanged () {
    this.checkIfInCart()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.onCartChanged) {
      window.BAO.eventBus.removeEventListener(
        window.BAO.EVENTS.PUSH_CART.CHANGED,
        this.onCartChanged,
      )
    }
  }

  showTemporaryMessage (message, duration = 2000) {
    const titleElement = this.els['product-title']?.element

    if (titleElement) {
      const originalText = titleElement.textContent
      titleElement.textContent = message

      setTimeout(() => {
        titleElement.textContent = originalText
      }, duration)
    }
  }

  showTick () {
    const tickElement = this.els.tick?.element
    if (tickElement) {
      tickElement.setAttribute('aria-hidden', 'false')
    }
  }

  hideTick () {
    const tickElement = this.els.tick?.element
    if (tickElement) {
      tickElement.setAttribute('aria-hidden', 'true')
    }
  }

  async checkIfInCart () {
    const variantId = this.dataset.productId

    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (response.ok) {
        const cartData = await response.json()
        const isInCart = cartData.items.some(
          (item) => item.id.toString() === variantId,
        )

        if (isInCart) {
          this.showTick()
        } else {
          this.hideTick()
        }
      }
    } catch (error) {
      console.error('Error checking cart status:', error)
    }
  }

  async addToCart () {
    const variantId = this.dataset.productId
    const isAvailable = this.dataset.productAvailable === 'true'

    if (!isAvailable) {
      this.showTemporaryMessage(window.theme.strings.soldOut)
      return
    }

    try {
      // Add loading state
      this.style.opacity = '0.7'
      this.style.pointerEvents = 'none'

      await window.BAO.Cart.addItem(
        {
          id: variantId,
          quantity: 1,
        },
        {
          sections: window.BAO.sectionRenderer.pushCartSections.map(
            (s) => s.section,
          ),
        },
      )

      this.showTemporaryMessage(window.theme.strings.addToCartSuccess)
      this.showTick()

      document.dispatchEvent(
        new CustomEvent('cart:item-added', {
          detail: {
            variantId,
            quantity: 1,
          },
        }),
      )

      setTimeout(() => {
        this.style.opacity = '1'
        this.style.pointerEvents = 'auto'
      }, 2000)
    } catch (error) {
      console.error('Add to cart error:', error)

      this.showTemporaryMessage(window.theme.strings.addToCartError)

      // Reset state
      this.style.opacity = '1'
      this.style.pointerEvents = 'auto'
    }
  }
}

if (!customElements.get('multi-column-grid-item')) {
  customElements.define('multi-column-grid-item', MultiColumnGridItem)
}
